import { useGetLoggedIn } from "_common/hooks/auth";

import Presentation from "./presentation";

const Component = () => {
	const isLoggedIn = useGetLoggedIn ();

	return (
		<Presentation
			isLoggedIn = { isLoggedIn }
		/>
	);
};

export default Component;